import React from 'react';

import ContextMenu from 'devextreme/ui/context_menu';

import CoreUtils from '../../common/utils/CoreUtils';
import ScheduleApi from '../../api-services/ScheduleApi';

import ScheduleMain from '../../schedules/ScheduleMain';
import ScheduleSelectionController from '../../schedules/controllers/ScheduleSelectionController';

import FlexHoursColumnManager from './FlexHoursColumnManager';
import FlexHoursDataModel from './FlexHoursDataModel';
import FlexHoursSummaryDataModel from './FlexHoursSummaryDataModel';
import FlexHoursSummaryView from './FlexHoursSummaryView';

export class FlexHoursMain extends ScheduleMain {
  constructor(props) {
    super(props);

    this.enactEditModeListener = this.enactEditMode.bind(this);

    this.summaryDataModel = new FlexHoursSummaryDataModel(this.counterparty.preferenceGroupName);

    this.selectionController = new ScheduleSelectionController(
      FlexHoursDataModel.scheduleIdProperty,
      FlexHoursDataModel.enableEditProperty,
      this.dataGridRef,
      this.isAltRowIndex,
      this.toolTipDelayMs,
      null,
      this.onSelectionControllerCancelPopups.bind(this),
      this.onSelectionControllerShowFieldTooltip.bind(this),
      this.onSelectionControllerHideFieldTooltip.bind(this)
    );

    this.dataModel = new FlexHoursDataModel(
      this.locale,
      this.counterparty,
      this.commandDataModel,
      this.summaryDataModel
    );

    this.columnManager = new FlexHoursColumnManager(
      this.session,
      this.counterparty
    );
    this.columnManager.settings.loadColumnSettings();
  }

  componentDidMount() {
    super.componentDidMount();

    this.commandDataModel.addEventListener('enactEditMode', this.enactEditModeListener);
  }

  componentWillUnmount() {
    this.commandDataModel.removeEventListener('enactEditMode', this.enactEditModeListener);

    this.summaryDataModel.dispose();

    super.componentWillUnmount();
  }

  renderUsageSummaries() {
    return (
      <FlexHoursSummaryView
        dataModel={this.summaryDataModel}
        locale={this.locale}
      />
    );
  }

  async loadGridValues() {
    this.closePopOutEditor();
    this.selectionController.clearCurrentSelection();

    var scheduleUpdateDto = await ScheduleApi.getFullUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth
    );

    this.dataModel.processFullServerUpdate(scheduleUpdateDto);

    this.selectionController.setEnableSelection(this.dataModel.isEditingEnabled);

    this.commandDataModel.updateProperties({
      isEditingEnabled: this.dataModel.isEditingEnabled,
      canUserManageColumnPreferences: scheduleUpdateDto.canUserManageColumnPreferences,
      showEditMode: this.dataModel.isEditingEnabled && scheduleUpdateDto.enableDirectEntry,
      currentContracts: this.dataModel.contracts,
      resubmitContracts: this.dataModel.contracts.filter(contract => contract.enableResubmitValues),
      recalculateContracts: this.dataModel.contracts.filter(contract => contract.enableRecalculateValues)
    });

    this.enactEditMode();
  }

  async updateGridValues(lastRetrievalTimeUtc) {
    var scheduleUpdateDto = await ScheduleApi.getPartialUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth,
      lastRetrievalTimeUtc
    );

    this.dataModel.processBackgroundServerUpdate(scheduleUpdateDto);
  }

  submitGridChanges(onSubmitFinished) {
    this.closePopOutEditor();
    this.selectionController.clearCurrentSelection();

    var dateSubmissions = this.dataModel.getCurrentModifications();
    ScheduleApi.submitChanges(
      this.counterparty.code,
      dateSubmissions,
      onSubmitFinished,
      false
    );
  }

  revertGridChanges() {
    this.closePopOutEditor();
    this.selectionController.clearCurrentSelection();
    this.dataModel.revertCurrentModifications();
  }

  enactEditMode() {
    if (this.commandDataModel.showEditMode) {
      this.dataModel.setActivateDirectEntry(!this.commandDataModel.useSelectionEditMode);
      this.selectionController.setActivateSelection(this.commandDataModel.useSelectionEditMode);
    } else {
      this.dataModel.setActivateDirectEntry(this.commandDataModel.isEditingEnabled);
      this.selectionController.setActivateSelection(this.commandDataModel.isEditingEnabled);
    }

    this.closePopOutEditor();
    this.resolveDataGrid().closeEditCell();
    this.selectionController.clearCurrentSelection();
  }

  onViewKeyDown(event) {
    super.onViewKeyDown(event);

    if (event.key === 'Escape') {
      this.closePopOutEditor();
      this.selectionController.clearCurrentSelection();
    }
  }

  updateCellAppearance(schedule, dataField, isAltRow, element) {
    if (CoreUtils.isDefinedAndNotNull(schedule))
      this.selectionController.updateCellAppearance(schedule.scheduleId, dataField, isAltRow, element);

    super.updateCellAppearance(schedule, dataField, isAltRow, element);
  }

  onDataGridCellHoverChanged(event) {
    this.selectionController.onCellHoverChanged(event);
  }

  onDataGridEditingStart(event) {
    super.onDataGridEditingStart(event);

    if (!event.cancel)
      this.selectionController.clearCurrentSelection();
  }

  onDataGridKeyDown(event) {
    if (event.event.code === 'Escape') {
      this.closePopOutEditor();
      this.selectionController.clearCurrentSelection();
    }
  }

  onDataGridContextMenuPreparing(event) {
    if (event.target !== 'content')
      return;

    var disabled = true;
    if (event.row !== undefined && this.selectionController.enableSelection && this.selectionController.activateSelection) {
      disabled = !this.selectionController.isCellSelected(event.row.key, event.column.dataField);

      if (disabled) {
        this.selectionController.selectCurrentCell();
        disabled = !this.selectionController.isCellSelected(event.row.key, event.column.dataField);
      }
    }

    if (disabled) {
      event.items = [];
      return;
    }

    event.items = [{
      text: 'Add Flex Hours',
      icon: 'plus',
      disabled: disabled,
      onItemClick: this.onFlexHoursMenuCommand.bind(this),
      addFlexHours: true
    }, {
      text: 'Remove Flex Hours',
      icon: 'minus',
      disabled: disabled,
      onItemClick: this.onFlexHoursMenuCommand.bind(this),
      addFlexHours: false
    }];
  }

  onFlexHoursMenuCommand(event) {
    var updateCount = this.dataModel.toggleFlexEnergyValues(
      this.selectionController.getCurrentSelection(),
      event.itemData.addFlexHours
    );

    if (updateCount > 0)
      this.selectionController.clearCurrentSelection();
  }

  onSelectionControllerCancelPopups(event) {
    var contextMenus = document.getElementsByClassName('dx-context-menu');
    for (var index = 0; index < contextMenus.length; index++) {
      var contextMenu = ContextMenu.getInstance(contextMenus[index]);
      if (CoreUtils.isDefinedAndNotNull(contextMenu))
        contextMenu.hide();
    };
  }

  onSelectionControllerShowFieldTooltip(event) {
    var dataGrid = this.resolveDataGrid();
    if (dataGrid !== null && dataGrid.getController('editing').isEditing())
      return false;

    return this.onShowDataGridToolTip(
      event.element,
      this.dataModel.resolveScheduleById(event.scheduleId),
      event.dataField
    );
  }

  onSelectionControllerHideFieldTooltip(event) {
    this.toolTipController.deactivate();
  }
}
